import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { __rest } from "tslib";
import React, { Component, createRef, cloneElement, Children } from 'react';
import { findDOMNode } from 'react-dom';
import * as PropTypes from 'prop-types';
import View from '../view';
import SwipeEvent from './SwipeEvent';
import cx from 'classnames';
import rpx2vw from './rpx2vw';
import './index.css';
var SWIPE_LEFT = 'SWIPE_LEFT';
var SWIPE_RIGHT = 'SWIPE_RIGHT';
var Slider = /*#__PURE__*/function (_Component) {
  _inherits(Slider, _Component);
  var _super = _createSuper(Slider);
  function Slider(props) {
    var _this;
    _classCallCheck(this, Slider);
    _this = _super.call(this, props);
    _this.onSwipeBegin = function () {
      _this.isSwiping = true;
      clearInterval(_this.autoPlayTimer);
    };
    _this.onSwipe = function (_ref) {
      var direction = _ref.direction,
        distance = _ref.distance,
        velocity = _ref.velocity;
      if (_this.isLoopEnd()) return;
      var changeX = distance / document.documentElement.clientWidth * 750 - _this.offsetX;
      var swipeView = findDOMNode(_this.swipeView.current);
      var styleText = "translate3d(".concat(rpx2vw(changeX + 'rpx'), ", 0, 0)");
      swipeView.style.transform = styleText;
      swipeView.style.webkitTransform = styleText;
    };
    _this.onSwipeEnd = function (_ref2) {
      var direction = _ref2.direction,
        distance = _ref2.distance,
        velocity = _ref2.velocity;
      _this.isSwiping = false;
      var num = _this.total;
      var realIndex = _this.loopedIndex();
      if (!(_this.isLoopEnd() && (realIndex === num - 1 && direction === SWIPE_LEFT || realIndex === 0 && direction === SWIPE_RIGHT))) {
        _this.slideTo(_this.index, direction);
      }
      if (_this.props.autoPlay) {
        _this.autoPlay();
      }
    };
    _this.getPages = function () {
      var children = _this.props.children;
      return Children.map(children, function (child, i) {
        var ref = /*#__PURE__*/createRef();
        var translateStyle = {
          width: rpx2vw(_this.width + 'rpx'),
          height: rpx2vw(_this.height + 'rpx'),
          left: rpx2vw(i * _this.width + 'rpx')
        };
        _this.childRefs[i] = ref;
        return /*#__PURE__*/React.createElement(View, {
          ref: ref,
          className: cx('one-slider-children', 'childWrap' + i),
          style: translateStyle,
          key: i
        }, child);
      });
    };
    _this.index = props.index;
    _this.height = parseFloat(props.height);
    _this.width = parseFloat(props.width);
    _this.loopIdx = props.index;
    _this.offsetX = _this.index * _this.width;
    _this.isSwiping = false;
    _this.swipeView = /*#__PURE__*/createRef();
    _this.childRefs = [];
    _this.total = 0;
    _this.autoPlayTimer = null;
    _this.isAutoPlay = false;
    return _this;
  }
  _createClass(Slider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoPlay && this.total > 1) {
        this.isAutoPlay = true;
        this.autoPlay();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (!this.isAutoPlay && this.props.autoPlay && this.total > 1) {
        this.isAutoPlay = true;
        this.autoPlay();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.autoPlayTimer && clearInterval(this.autoPlayTimer);
    }
  }, {
    key: "autoPlay",
    value: function autoPlay() {
      var _this2 = this;
      var autoPlayInterval = this.props.autoPlayInterval;
      if (this.isSwiping) return;
      this.autoPlayTimer && clearInterval(this.autoPlayTimer);
      var interval = function interval() {
        if (_this2.isLoopEnd()) return;
        _this2.slideTo(_this2.index, SWIPE_LEFT);
      };
      this.autoPlayTimer = setInterval(interval, autoPlayInterval);
    }
  }, {
    key: "slideTo",
    value: function slideTo(index, direction) {
      if (this.isSwiping) return;
      if (direction) {
        this.index = direction === SWIPE_LEFT ? index + 1 : index - 1;
      } else {
        this.index = index;
      }
      this.offsetX = this.index * this.width;
      var realIndex = this.loopedIndex();
      var swipeView = findDOMNode(this.swipeView.current);
      var styleText = "translate3d(".concat(rpx2vw(-1 * this.offsetX + 'rpx'), ", 0, 0)");
      swipeView.style.transform = styleText;
      swipeView.style.webkitTransform = styleText;
      this.loopIdx = this.index < 0 && realIndex !== 0 ? this.total - realIndex : realIndex;
      this.childRefs[this.loopIdx].current.style.left = this.offsetX / 750 * document.documentElement.clientWidth + 'px';
      if (this.props.onChange) {
        this.props.onChange({
          index: this.loopIdx
        });
      }
      this.forceUpdate();
      if (this.props.autoPlay) {
        this.autoPlay();
      }
    }
  }, {
    key: "isLoopEnd",
    value: function isLoopEnd() {
      var realIndex = this.loopedIndex();
      var num = this.total;
      if (!this.props.loop && (realIndex === num - 1 || realIndex === 0)) {
        return true;
      }
      return false;
    }
  }, {
    key: "loopedIndex",
    value: function loopedIndex() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.index;
      var total = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.total;
      return Math.abs(index) % total;
    }
  }, {
    key: "renderPagination",
    value: function renderPagination() {
      if (this.total <= 1) return null;
      var _this$props = this.props,
        _this$props$paginatio = _this$props.paginationStyle,
        paginationStyle = _this$props$paginatio === void 0 ? {} : _this$props$paginatio,
        activeDot = _this$props.activeDot,
        normalDot = _this$props.normalDot;
      var dots = [];
      var itemSize = paginationStyle.itemSize,
        itemColor = paginationStyle.itemColor,
        itemSelectedColor = paginationStyle.itemSelectedColor,
        otherStyle = __rest(paginationStyle, ["itemSize", "itemColor", "itemSelectedColor"]);
      var size = {
        width: itemSize,
        height: itemSize
      };
      var ActiveDot = activeDot || /*#__PURE__*/React.createElement(View, {
        className: "one-slider-dot one-slider-dot-active",
        style: Object.assign({
          backgroundColor: itemSelectedColor
        }, size)
      });
      var NormalDot = normalDot || /*#__PURE__*/React.createElement(View, {
        className: "one-slider-dot",
        style: Object.assign({
          backgroundColor: itemColor
        }, size)
      });
      var realIndex = this.loopIdx;
      for (var i = 0; i < this.total; i++) {
        dots.push(i === realIndex ? /*#__PURE__*/cloneElement(ActiveDot, {
          key: i
        }) : /*#__PURE__*/cloneElement(NormalDot, {
          key: i
        }));
      }
      return /*#__PURE__*/React.createElement(View, {
        className: "one-slider-pagination",
        style: otherStyle
      }, dots);
    }
  }, {
    key: "renderSwipeView",
    value: function renderSwipeView(pages) {
      var _this$props2 = this.props,
        initialVelocityThreshold = _this$props2.initialVelocityThreshold,
        verticalThreshold = _this$props2.verticalThreshold,
        vertical = _this$props2.vertical,
        horizontalThreshold = _this$props2.horizontalThreshold;
      var style = {
        width: rpx2vw(this.width + 'rpx'),
        height: rpx2vw(this.height + 'rpx')
      };
      return this.total > 1 ? ( /*#__PURE__*/React.createElement(SwipeEvent, {
        className: "one-slider-swipe-wrapper",
        style: style,
        onSwipeBegin: this.onSwipeBegin,
        onSwipeEnd: this.onSwipeEnd,
        onSwipe: this.onSwipe,
        initialVelocityThreshold: initialVelocityThreshold,
        verticalThreshold: verticalThreshold,
        vertical: vertical,
        horizontalThreshold: horizontalThreshold
      }, /*#__PURE__*/React.createElement(View, {
        ref: this.swipeView,
        className: "one-slider-swipe",
        style: Object.assign(Object.assign({}, style), {
          transform: "translate3d(".concat(rpx2vw(-1 * this.offsetX + 'rpx'), ", 0, 0)")
        })
      }, pages))) : ( /*#__PURE__*/React.createElement(View, {
        ref: this.swipeView,
        className: "one-slider-swipe",
        style: style
      }, pages));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        style = _this$props3.style,
        _this$props3$showsPag = _this$props3.showsPagination,
        showsPagination = _this$props3$showsPag === void 0 ? true : _this$props3$showsPag,
        className = _this$props3.className,
        children = _this$props3.children;
      this.total = Children.toArray(children).length;
      return /*#__PURE__*/React.createElement(View, {
        style: style,
        className: cx('one-slider', className)
      }, this.renderSwipeView(this.getPages()), showsPagination && this.renderPagination());
    }
  }]);
  return Slider;
}(Component);
Slider.defaultProps = {
  horizontal: true,
  showsPagination: true,
  loop: true,
  autoPlay: false,
  autoPlayInterval: 3000,
  index: 0,
  paginationStyle: {},
  initialVelocityThreshold: 0.7,
  verticalThreshold: 10,
  horizontalThreshold: 10,
  vertical: false
};
Slider.propTypes = {
  onChange: PropTypes.func,
  paginationStyle: PropTypes.object
};
export default Slider;